import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import HotelLoader from './hotel/HotelLoader.react';
import HotelCardComponent from './hotel/HotelCardComponent.react';
import { hotelElementsStore } from './HotelElementsStore';

class HotelList extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this._unsubscribe = hotelElementsStore.subscribe(() => this.forceUpdate());
        hotelElementsStore._onStoreChange();
    }

    componentWillUnmount() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    render() {
        const { showLoaders } = this.props;
        const {
            profile,
            searchToken,
            searchTerms,
            completed_hotels,
            completed_search,
            completed_listening,
            breakfast_only,
            free_cancellation_only,
            completed_delay,
            arbitrip_points_applied,
            amenities_data,
            private_travel,
            contract_client_company_id,
        } = this.props;

        return (
            <Virtuoso
                useWindowScroll
                totalCount={showLoaders ? 10 : hotelElementsStore.getCount()}
                itemContent={(index) => {
                    if (showLoaders) {
                        return <HotelLoader hotel={{ id: index }} />;
                    }
                    const hotel = hotelElementsStore.getItem(index);
                    if (!hotel) return null;
                    return (
                        <HotelCardComponent
                            hotel={hotel}
                            key={'hotel-key-' + hotel.id}
                            searchToken={searchToken}
                            searchTerms={searchTerms}
                            profile={profile}
                            enableDealLoader={!!(completed_hotels || completed_search)}
                            completedListening={!!completed_listening}
                            breakfastOnly={!!breakfast_only}
                            freeCancellationOnly={!!free_cancellation_only}
                            forceDealLoader={!completed_delay}
                            arbitripPointsApplied={!!arbitrip_points_applied}
                            amenitiesData={amenities_data}
                            sortPosition={index + 1}
                            privateTravel={!!private_travel}
                            contract_client_company_id={contract_client_company_id}
                        />
                    );
                }}
            />
        );
    }
}

export default HotelList;
